var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"emtions"}},[_c('ul',_vm._l((_vm.emtions),function(v,i){return _c('li',{key:i},[_c('img',{attrs:{"src":v.src,"alt":"","title":v.sname},on:{"click":function($event){return _vm.selectFun(v.name,v.src,v.nickname)}}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db4f2614","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatPlaza/emotions/emtion.vue
// module id = null
// module chunks = 